import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from "@angular/core";
import { EdpModalService } from "@edp-components/edp-modal";
import { ListItem } from "@edp-models/lists.model";
import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ModalFilterPickerComponent } from "./modal-filter-picker/modal-filter-picker.component";
import { SCREEN_SIZES } from "@edp-enums/screen-sizes.enum";

@Component({
    selector: "edp-filter-picker",
    templateUrl: "./edp-filter-picker.component.html",
    styleUrls: ["./edp-filter-picker.component.scss"],
})
export class EdpFilterPickerComponent {
    @Input() label: string;
    @Input() filterList: ListItem[];
    @Input() selectedFilter: ListItem;
    @Input() prefixLabel: string;
    @Input() modalOnMobile = false;
    @Input() modalTitle = "";
    @Output() filterSelected = new EventEmitter();
    @ViewChild("filterPicker", { static: false }) filterPicker: ElementRef<HTMLElement>;
    @Input() helperLabel: string;

    showFilterPicker = false;
    mobileSize = false;

    @HostListener("document:click", ["$event"])
    clickout(event: { target: Node }) {
        if (!!this.filterPicker) {
            const filterPickerContainer = this.filterPicker.nativeElement;
            if (filterPickerContainer && !filterPickerContainer.contains(event.target)) {
                this.showFilterPicker = false;
            }
        }
    }

    @HostListener("window:resize")
    private onResize() {
        this.mobileSize = false;
        if (window.innerWidth < SCREEN_SIZES.WDGT) {
            this.mobileSize = true;
        }
    }

    constructor(private edpModalService: EdpModalService) {
        this.onResize();
    }

    public selectFilter(selectedFilter: any): void {
        this.showFilterPicker = false;
        this.selectedFilter = selectedFilter;
        this.filterSelected.emit(selectedFilter);
    }

    public showFilterList() {
        if (this.mobileSize && this.modalOnMobile) {
            this.openModalFilter();
            return;
        }
        this.showFilterPicker = !this.showFilterPicker;
    }

    public openModalFilter() {
        const modalOptions: NgbModalOptions = { windowClass: "edp-modal-window modal-filter-picker" };

        this.edpModalService
            .custom(ModalFilterPickerComponent, modalOptions, {
                collection: {
                    title: this.modalTitle,
                    filterList: this.filterList,
                    selectedFilter: this.selectedFilter,
                },
            })
            .then(response => {
                if (!!response?.selectedFilter) {
                    this.selectFilter(response?.selectedFilter);
                    return;
                }
            });
    }
}
